import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { UmssAvatarComponent } from '../avatar/avatar.component';

export interface AvatarStackItem {
  src?: string;
  name?: string;
  initials?: string;
  status?: 'Online' | 'Offline' | 'Away' | 'Busy';
}

@Component({
  selector: 'umss-avatar-stack',
  standalone: true,
  imports: [CommonModule, UmssAvatarComponent],
  templateUrl: './avatar-stack.component.html',
  styleUrls: ['./avatar-stack.component.scss']
})
export class UmssAvatarStackComponent {
  @HostBinding('style.display') display = 'contents';

  /** Content props */
  @Input() avatars: AvatarStackItem[] = [];
  @Input() maxVisible: number = 3;
  @Input() showCount: boolean = true;

  /** Variant props */
  @Input() size: 'XSmall' | 'Small' | 'Regular' | 'Large' = 'Small';
  @Input() shape: 'Circle' | 'Square' | 'Rounded' = 'Circle';
  @Input() spacing: 'Tight' | 'Regular' | 'Loose' = 'Regular';

  /** State props */
  @Input() disabled: boolean = false;

  /** Computed properties */
  get visibleAvatars(): AvatarStackItem[] {
    return this.avatars.slice(0, this.maxVisible);
  }

  get remainingCount(): number {
    return Math.max(0, this.avatars.length - this.maxVisible);
  }

  get hasRemaining(): boolean {
    return this.remainingCount > 0 && this.showCount;
  }

  /** Helper methods */
  trackByIndex(index: number): number {
    return index;
  }
}
